export default "__VITE_ASSET__CluT2TuT__"